module.exports = [
	{
		"id": "13242000",
		"image": "//cdn.cloud.grohe.com/prod/10/13/13242000/640/13242000.jpg",
		"headline": "Veris",
		"subheadline": "Bath spout",
		"textblock_1st_text": "13242000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe-middleeast.com/en_cy/product/13242000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe-middleeast.com/en_cy/our-service/showrooms-installer.html#productline=G228",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "13280001",
		"image": "//cdn.cloud.grohe.com/prod/10/13/13280001/640/13280001.jpg",
		"headline": "Concetto",
		"subheadline": "Bath spout",
		"textblock_1st_text": "13280001",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe-middleeast.com/en_cy/product/13280001",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe-middleeast.com/en_cy/our-service/showrooms-installer.html#productline=G187",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "34195001",
		"image": "//cdn.cloud.grohe.com/prod/30/34/34195001/640/34195001.jpg",
		"headline": "Grohtherm 2000",
		"subheadline": "Safety shower mixer 1/2\" with shower set",
		"textblock_1st_text": "34195001",
		"textblock_2nd_text": "Grohtherm 2000 shower thermostat with GROHE Euphoria shower rail set (consisting of 110mm hand shower with three spray options, 600 mm rail, 1750mm hose and tray)",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe-middleeast.com/en_cy/product/34195001",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe-middleeast.com/en_cy/our-service/showrooms-installer.html#productline=G367",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27673000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27673000/640/27673000.jpg",
		"headline": "Power&Soul 130",
		"subheadline": "Hand shower 4+ sprays, spray plate night time grey",
		"textblock_1st_text": "27673000",
		"textblock_2nd_text": "GROHE Power&Soul hand shower, 130 mm, 9.5 l/min",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe-middleeast.com/en_cy/product/27673000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe-middleeast.com/en_cy/our-service/showrooms-installer.html#productline=G316",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27698000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27698000/640/27698000.jpg",
		"headline": "Euphoria Cube Stick",
		"subheadline": "Hand shower 1 spray",
		"textblock_1st_text": "27698000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe-middleeast.com/en_cy/product/27698000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe-middleeast.com/en_cy/our-service/showrooms-installer.html#productline=G334",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27699000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27699000/640/27699000.jpg",
		"headline": "Euphoria Cube Stick",
		"subheadline": "Hand shower 1 spray",
		"textblock_1st_text": "27699000",
		"textblock_2nd_text": "GROHE Euphoria Cube Stick, hand shower, 1 spray",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe-middleeast.com/en_cy/product/27699000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe-middleeast.com/en_cy/our-service/showrooms-installer.html#productline=G334",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27700000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27700000/640/27700000.jpg",
		"headline": "Euphoria Cube Stick",
		"subheadline": "Shower rail set 1 spray",
		"textblock_1st_text": "27700000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe-middleeast.com/en_cy/product/27700000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe-middleeast.com/en_cy/our-service/showrooms-installer.html#productline=G334",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27704000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27704000/640/27704000.jpg",
		"headline": "Euphoria Cube",
		"subheadline": "Shower outlet elbow 1/2\"",
		"textblock_1st_text": "27704000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe-middleeast.com/en_cy/product/27704000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe-middleeast.com/en_cy/our-service/showrooms-installer.html#productline=G334",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27705000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27705000/640/27705000.jpg",
		"headline": "Euphoria Cube 150",
		"subheadline": "Head shower 1 spray",
		"textblock_1st_text": "27705000",
		"textblock_2nd_text": "GROHE Euphoria Cube 150 head shower with Rain Spray Chrome finish, Made in Germany, with water saving feature",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe-middleeast.com/en_cy/product/27705000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe-middleeast.com/en_cy/our-service/showrooms-installer.html#productline=G334",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27734000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27734000/640/27734000.jpg",
		"headline": "Power&Soul Cosmopolitan 130",
		"subheadline": "Shower rail set 4+ sprays",
		"textblock_1st_text": "27734000",
		"textblock_2nd_text": "GROHE Power&Soul Cosmopolitan set with hand shower (130 mm), shower rail (900 mm) and shower hose (1,750 mm), 9.5 l/min",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe-middleeast.com/en_cy/product/27734000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe-middleeast.com/en_cy/our-service/showrooms-installer.html#productline=G315",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27738000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27738000/640/27738000.jpg",
		"headline": "Power&Soul 130",
		"subheadline": "Shower rail set 4+ sprays",
		"textblock_1st_text": "27738000",
		"textblock_2nd_text": "GROHE Power&Soul set with hand shower (130 mm), shower rail (900 mm) and shower hose (1,750 mm), 9.5 l/min",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe-middleeast.com/en_cy/product/27738000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe-middleeast.com/en_cy/our-service/showrooms-installer.html#productline=G316",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27741000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27741000/640/27741000.jpg",
		"headline": "Power&Soul Cosmopolitan 130",
		"subheadline": "Wall holder set 4+ sprays",
		"textblock_1st_text": "27741000",
		"textblock_2nd_text": "GROHE Power&Soul Cosmopolitan set with hand shower (115 mm), shower hose (1,250 mm) and hand shower holder",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe-middleeast.com/en_cy/product/27741000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe-middleeast.com/en_cy/our-service/showrooms-installer.html#productline=G315",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27750000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27750000/640/27750000.jpg",
		"headline": "Power&Soul 160",
		"subheadline": "Shower rail set 4+ sprays",
		"textblock_1st_text": "27750000",
		"textblock_2nd_text": "GROHE Power&Soul set with hand shower (160 mm), shower rail (900 mm) and shower hose (1,750 mm), 9.5 l/min",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe-middleeast.com/en_cy/product/27750000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe-middleeast.com/en_cy/our-service/showrooms-installer.html#productline=G316",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27755000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27755000/640/27755000.jpg",
		"headline": "Power&Soul Cosmopolitan 115",
		"subheadline": "Shower rail set 2 sprays",
		"textblock_1st_text": "27755000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe-middleeast.com/en_cy/product/27755000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe-middleeast.com/en_cy/our-service/showrooms-installer.html#productline=G315",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27759000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27759000/640/27759000.jpg",
		"headline": "Power&Soul 115",
		"subheadline": "Shower rail set 2 sprays",
		"textblock_1st_text": "27759000",
		"textblock_2nd_text": "GROHE Power&Soul set with hand shower (115 mm), shower rail (900 mm) and shower hose (1,750 mm)",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe-middleeast.com/en_cy/product/27759000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe-middleeast.com/en_cy/our-service/showrooms-installer.html#productline=G316",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27785000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27785000/640/27785000.jpg",
		"headline": "Power&Soul",
		"subheadline": "Shower rail, 900 mm",
		"textblock_1st_text": "27785000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe-middleeast.com/en_cy/product/27785000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe-middleeast.com/en_cy/our-service/showrooms-installer.html#productline=G316",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27967000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27967000/640/27967000.jpg",
		"headline": "Rainshower System 210",
		"subheadline": "Shower system with Safety Mixer for wall mounting",
		"textblock_1st_text": "27967000",
		"textblock_2nd_text": "GROHE Rainshower 210 shower system with thermostat",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe-middleeast.com/en_cy/product/27967000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe-middleeast.com/en_cy/our-service/showrooms-installer.html#productline=G212",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27968000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27968000/640/27968000.jpg",
		"headline": "Rainshower System 310",
		"subheadline": "Shower system with Safety Mixer for wall mounting",
		"textblock_1st_text": "27968000",
		"textblock_2nd_text": "GROHE Rainshower 310 shower system with thermostat",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe-middleeast.com/en_cy/product/27968000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe-middleeast.com/en_cy/our-service/showrooms-installer.html#productline=G212",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "13303000",
		"image": "//cdn.cloud.grohe.com/prod/10/13/13303000/640/13303000.jpg",
		"headline": "Eurocube",
		"subheadline": "Bath spout",
		"textblock_1st_text": "13303000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe-middleeast.com/en_cy/product/13303000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe-middleeast.com/en_cy/our-service/showrooms-installer.html#productline=G320",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27641000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27641000/640/27641000.jpg",
		"headline": "Rainshower System 210",
		"subheadline": "Shower system with Bath Safety Mixer for wall mounting",
		"textblock_1st_text": "27641000",
		"textblock_2nd_text": "GROHE Rainshower 210 shower system with thermostat and bath spout",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe-middleeast.com/en_cy/product/27641000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe-middleeast.com/en_cy/our-service/showrooms-installer.html#productline=G212",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "28362000",
		"image": "//cdn.cloud.grohe.com/prod/20/28/28362000/640/28362000.jpg",
		"headline": "Silverflex",
		"subheadline": "Shower hose Twistfree 1250",
		"textblock_1st_text": "28362000",
		"textblock_2nd_text": "GROHE Silver Flex hose with swivel connector for TwistFree function, 1250 mm",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe-middleeast.com/en_cy/product/28362000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe-middleeast.com/en_cy/our-service/showrooms-installer.html#productline=X999",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "28990000",
		"image": "//cdn.cloud.grohe.com/prod/20/28/28990000/640/28990000.jpg",
		"headline": "Talentofill",
		"subheadline": "Inlet, pop-up and waste-system",
		"textblock_1st_text": "28990000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe-middleeast.com/en_cy/product/28990000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe-middleeast.com/en_cy/our-service/showrooms-installer.html#productline=X999",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "23147001",
		"image": "//cdn.cloud.grohe.com/prod/20/23/23147001/640/23147001.jpg",
		"headline": "Euphoria Cube System 230",
		"subheadline": "Shower system with single lever mixer for wall mounting",
		"textblock_1st_text": "23147001",
		"textblock_2nd_text": "GROHE Euphoria Cube XXL Shower System with single lever mixer; chrome and German engineered with 230mm metal head shower and one-spray hand shower.",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe-middleeast.com/en_cy/product/23147001",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe-middleeast.com/en_cy/our-service/showrooms-installer.html#productline=G365",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26075000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26075000/640/26075000.jpg",
		"headline": "Euphoria System 310",
		"subheadline": "Shower system with safety mixer for wall mounting",
		"textblock_1st_text": "26075000",
		"textblock_2nd_text": "GROHE Euphoria XXL Shower System with thermostat; chrome and German engineered with 310mm metal head shower and 110mm three-spray hand shower.",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe-middleeast.com/en_cy/product/26075000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe-middleeast.com/en_cy/our-service/showrooms-installer.html#productline=G236",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27615001",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27615001/640/27615001.jpg",
		"headline": "Euphoria System 260",
		"subheadline": "Shower system with Safety Mixer for wall mounting",
		"textblock_1st_text": "27615001",
		"textblock_2nd_text": "GROHE Euphoria 260 Shower System with thermostat, water saving SmartControl 260mm 3-spray head shower and 110mm 3-spray hand shower in chrome. Easy to fit and clean. German engineering",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe-middleeast.com/en_cy/product/27615001",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe-middleeast.com/en_cy/our-service/showrooms-installer.html#productline=G236",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26254000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26254000/640/26254000.jpg",
		"headline": "Rainshower Duo 360",
		"subheadline": "Head shower set 450 mm, 2 sprays",
		"textblock_1st_text": "26254000",
		"textblock_2nd_text": "GROHE Rainshower 360 DUO  head shower set. Chrome, made in Germany: 360mm head shower with GROHE TrioMassage spray and 450mm shower arm.",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe-middleeast.com/en_cy/product/26254000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe-middleeast.com/en_cy/our-service/showrooms-installer.html#productline=G421",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27966000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27966000/640/27966000.jpg",
		"headline": "Rainshower System 310",
		"subheadline": "Shower system with Safety Mixer for wall mounting",
		"textblock_1st_text": "27966000",
		"textblock_2nd_text": "GROHE Rainshower 310 shower system with thermostat",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe-middleeast.com/en_cy/product/27966000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe-middleeast.com/en_cy/our-service/showrooms-installer.html#productline=G212",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "28364000",
		"image": "//cdn.cloud.grohe.com/prod/20/28/28364000/640/28364000.jpg",
		"headline": "Silverflex",
		"subheadline": "Shower hose Twistfree 1500",
		"textblock_1st_text": "28364000",
		"textblock_2nd_text": "GROHE Silver Flex hose with swivel connector for TwistFree function, 1500 mm",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe-middleeast.com/en_cy/product/28364000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe-middleeast.com/en_cy/our-service/showrooms-installer.html#productline=X999",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "28388000",
		"image": "//cdn.cloud.grohe.com/prod/20/28/28388000/640/28388000.jpg",
		"headline": "Silverflex",
		"subheadline": "Shower hose Twistfree 1750",
		"textblock_1st_text": "28388000",
		"textblock_2nd_text": "GROHE Silver Flex hose with swivel connector for TwistFree function, 1750 mm",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe-middleeast.com/en_cy/product/28388000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe-middleeast.com/en_cy/our-service/showrooms-installer.html#productline=X999",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26483000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26483000/640/26483000.jpg",
		"headline": "Rainshower",
		"subheadline": "Universal rough-in box, 1/2\"",
		"textblock_1st_text": "26483000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe-middleeast.com/en_cy/product/26483000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe-middleeast.com/en_cy/our-service/showrooms-installer.html#productline=G480",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "29124000",
		"image": "//cdn.cloud.grohe.com/prod/20/29/29124000/640/29124000.jpg",
		"headline": "Grohtherm SmartControl",
		"subheadline": "Safety mixer  for concealed installation with 2 valves",
		"textblock_1st_text": "29124000",
		"textblock_2nd_text": "Grohtherm SmartControl thermostat for shower or bath, for concealed installation, with two valves. Square shape, chrome finish, made in Germany by GROHE. Eco-friendly and safety features",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe-middleeast.com/en_cy/product/29124000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe-middleeast.com/en_cy/our-service/showrooms-installer.html#productline=G422",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26254LS0",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26254LS0/640/26254LS0.jpg",
		"headline": "Rainshower Duo 360",
		"subheadline": "Head shower set 450 mm, 2 sprays",
		"textblock_1st_text": "26254LS0",
		"textblock_2nd_text": "GROHE Rainshower 360 DUO  head shower set.Chrome, made in Germany: 360mm head shower (white spray plate) with GROHE TrioMassage spray and 450mm shower arm.",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe-middleeast.com/en_cy/product/26254LS0",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe-middleeast.com/en_cy/our-service/showrooms-installer.html#productline=G421",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26264001",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26264001/640/26264001.jpg",
		"headline": "Rainshower 360",
		"subheadline": "Rough-in box for head shower set",
		"textblock_1st_text": "26264001",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe-middleeast.com/en_cy/product/26264001",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe-middleeast.com/en_cy/our-service/showrooms-installer.html#productline=G421",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26443000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26443000/640/26443000.jpg",
		"headline": "Rainshower System SmartControl Duo 360",
		"subheadline": "Combi shower system with safety mixer, exposed/concealed",
		"textblock_1st_text": "26443000",
		"textblock_2nd_text": "GROHE Rainshower SmartControl 360 DUO Combi shower system with termostat. Chrome, eco-friendly and made in Germany: 360mm head shower with GROHE TrioMassage spray and 115mm hand shower with two sprays.",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe-middleeast.com/en_cy/product/26443000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe-middleeast.com/en_cy/our-service/showrooms-installer.html#productline=G421",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "34713000",
		"image": "//cdn.cloud.grohe.com/prod/30/34/34713000/640/34713000.jpg",
		"headline": "Grohtherm SmartControl",
		"subheadline": "Combi safety shower mixer with <br />3 valves, exposed/concealed",
		"textblock_1st_text": "34713000",
		"textblock_2nd_text": "GROHE Grohtherm SmartControl Combi shower thermostat with three valves. Chrome with white tray, German engineered.",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe-middleeast.com/en_cy/product/34713000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe-middleeast.com/en_cy/our-service/showrooms-installer.html#productline=G422",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26475000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26475000/640/26475000.jpg",
		"headline": "Rainshower SmartActive 310",
		"subheadline": "Head shower set 430 mm, 2 sprays",
		"textblock_1st_text": "26475000",
		"textblock_2nd_text": "GROHE Rainshower 310 SmartActive head shower set with 2 spray options. 310mm wall-mounted showerhead with 400mm shower arm, chrome finish, round shape. Made in Germany",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe-middleeast.com/en_cy/product/26475000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe-middleeast.com/en_cy/our-service/showrooms-installer.html#productline=G480",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "19952000",
		"image": "//cdn.cloud.grohe.com/prod/10/19/19952000/640/19952000.jpg",
		"headline": "Talentofill",
		"subheadline": "Inlet, pop-up and waste-system",
		"textblock_1st_text": "19952000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe-middleeast.com/en_cy/product/19952000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe-middleeast.com/en_cy/our-service/showrooms-installer.html#productline=X999",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26477000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26477000/640/26477000.jpg",
		"headline": "Rainshower SmartActive 310",
		"subheadline": "Head shower set ceiling 142 mm, 2 sprays",
		"textblock_1st_text": "26477000",
		"textblock_2nd_text": "GROHE Rainshower 310 SmartActive head shower set with 2 spray options. 310mm ceiling-mounted showerhead with 142mm shower arm, chrome finish, round shape. Made in Germany",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe-middleeast.com/en_cy/product/26477000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe-middleeast.com/en_cy/our-service/showrooms-installer.html#productline=G480",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26481000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26481000/640/26481000.jpg",
		"headline": "Rainshower SmartActive 310 Cube",
		"subheadline": "Head shower set ceiling 142 mm, 2 sprays",
		"textblock_1st_text": "26481000",
		"textblock_2nd_text": "GROHE Rainshower 310 SmartActive CUBE head shower set with 2 spray options. 310mm ceiling-mounted showerhead with 142mm shower arm, chrome finish, square shape. Made in Germany",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe-middleeast.com/en_cy/product/26481000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe-middleeast.com/en_cy/our-service/showrooms-installer.html#productline=G480",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26459000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26459000/640/26459000.jpg",
		"headline": "Euphoria 260",
		"subheadline": "Head shower set 380 mm, 3 sprays",
		"textblock_1st_text": "26459000",
		"textblock_2nd_text": "GROHE Euphoria 260 SmartControl head shower set with three spray zones. Water saving 260mm shower head and GROHE Rainshower arm (380mm) with chrome finish. Easy to fit and clean. Made in Germany",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe-middleeast.com/en_cy/product/26459000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe-middleeast.com/en_cy/our-service/showrooms-installer.html#productline=G204",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26250LS0",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26250LS0/640/26250LS0.jpg",
		"headline": "Rainshower System SmartControl Duo 360",
		"subheadline": "Shower system with Safety Mixer for wall mounting",
		"textblock_1st_text": "26250LS0",
		"textblock_2nd_text": "GROHE Rainshower SmartControl 360 DUO Exposed shower system with thermostat. Chrome, eco-friendly and made in Germany, 360mm head shower (white spray plate) with GROHE TrioMassage spray and 115mm hand shower with two sprays.",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe-middleeast.com/en_cy/product/26250LS0",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe-middleeast.com/en_cy/our-service/showrooms-installer.html#productline=G421",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26250000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26250000/640/26250000.jpg",
		"headline": "Rainshower System SmartControl Duo 360",
		"subheadline": "Shower system with Safety Mixer for wall mounting",
		"textblock_1st_text": "26250000",
		"textblock_2nd_text": "GROHE Rainshower SmartControl 360 DUO Exposed shower system with thermostat. Chrome, eco-friendly and made in Germany, 360mm head shower with GROHE TrioMassage spray and 115mm hand shower with two sprays.",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe-middleeast.com/en_cy/product/26250000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe-middleeast.com/en_cy/our-service/showrooms-installer.html#productline=G421",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26174LS0",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26174LS0/640/26174LS0.jpg",
		"headline": "Power&Soul Cosmopolitan",
		"subheadline": "Wall holder set 4+ sprays",
		"textblock_1st_text": "26174LS0",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe-middleeast.com/en_cy/product/26174LS0",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe-middleeast.com/en_cy/our-service/showrooms-installer.html#productline=G315",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27389001",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27389001/640/27389001.jpg",
		"headline": "Tempesta System 200",
		"subheadline": "Shower system with diverter for wall mounting",
		"textblock_1st_text": "27389001",
		"textblock_2nd_text": "GROHE New Tempesta 200 FLEX Shower System with diverter; compatible with all existing valves for easy upgrades. Made in Germany with 200m two-spray head shower and 100mm four-spray hand shower.",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe-middleeast.com/en_cy/product/27389001",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe-middleeast.com/en_cy/our-service/showrooms-installer.html#productline=G391",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26087000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26087000/640/26087000.jpg",
		"headline": "Euphoria Cube System 230",
		"subheadline": "Shower system with safety mixer for wall mounting",
		"textblock_1st_text": "26087000",
		"textblock_2nd_text": "GROHE Euphoria Cube XXL 230 shower system with thermostat",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe-middleeast.com/en_cy/product/26087000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe-middleeast.com/en_cy/our-service/showrooms-installer.html#productline=G365",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26171LS0",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26171LS0/640/26171LS0.jpg",
		"headline": "Rainshower Cosmopolitan 210",
		"subheadline": "Head shower set 422 mm, 1 spray",
		"textblock_1st_text": "26171LS0",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe-middleeast.com/en_cy/product/26171LS0",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe-middleeast.com/en_cy/our-service/showrooms-installer.html#productline=G372",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "29125000",
		"image": "//cdn.cloud.grohe.com/prod/20/29/29125000/640/29125000.jpg",
		"headline": "Grohtherm SmartControl",
		"subheadline": "Safety mixer  for concealed installation with 2 valves <br />and integrated shower holder",
		"textblock_1st_text": "29125000",
		"textblock_2nd_text": "Grohtherm SmartControl thermostat for shower or bath, for concealed installation, with two valves valves and integrated shower union. Square shape, chrome finish, made in Germany by GROHE. Eco-friendly and safety features",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe-middleeast.com/en_cy/product/29125000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe-middleeast.com/en_cy/our-service/showrooms-installer.html#productline=G422",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "29126000",
		"image": "//cdn.cloud.grohe.com/prod/20/29/29126000/640/29126000.jpg",
		"headline": "Grohtherm SmartControl",
		"subheadline": "Safety mixer for concealed installation with 3 valves",
		"textblock_1st_text": "29126000",
		"textblock_2nd_text": "Grohtherm SmartControl thermostat for shower or bath, for concealed installation, with three valves. Square shape, chrome finish, made in Germany by GROHE. Eco-friendly and safety features",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe-middleeast.com/en_cy/product/29126000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe-middleeast.com/en_cy/our-service/showrooms-installer.html#productline=G422",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "29150LS0",
		"image": "//cdn.cloud.grohe.com/prod/20/29/29150LS0/640/29150LS0.jpg",
		"headline": "Grohtherm SmartControl",
		"subheadline": "Safety mixer for concealed installation with one valve",
		"textblock_1st_text": "29150LS0",
		"textblock_2nd_text": "Grohtherm SmartControl thermostat for shower, with concealed installation and one valve. Round shape, Moon White, made in Germany by GROHE. Eco-friendly and safety features",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe-middleeast.com/en_cy/product/29150LS0",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe-middleeast.com/en_cy/our-service/showrooms-installer.html#productline=G422",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "29151LS0",
		"image": "//cdn.cloud.grohe.com/prod/20/29/29151LS0/640/29151LS0.jpg",
		"headline": "Grohtherm SmartControl",
		"subheadline": "Safety mixer  for concealed installation with 2 valves",
		"textblock_1st_text": "29151LS0",
		"textblock_2nd_text": "Grohtherm SmartControl thermostat for shower or bath, for concealed installation, with two valves. Round shape, Moon White, made in Germany by GROHE. Eco-friendly and safety features",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe-middleeast.com/en_cy/product/29151LS0",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe-middleeast.com/en_cy/our-service/showrooms-installer.html#productline=G422",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "29904LS0",
		"image": "//cdn.cloud.grohe.com/prod/20/29/29904LS0/640/29904LS0.jpg",
		"headline": "Grohtherm SmartControl",
		"subheadline": "Safety mixer for concealed installation with 3 valves",
		"textblock_1st_text": "29904LS0",
		"textblock_2nd_text": "Grohtherm SmartControl thermostat for shower or bath, for concealed installation, with three valves. Round shape, Moon White, made in Germany by GROHE. Eco-friendly and safety features",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe-middleeast.com/en_cy/product/29904LS0",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe-middleeast.com/en_cy/our-service/showrooms-installer.html#productline=G422",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "29153LS0",
		"image": "//cdn.cloud.grohe.com/prod/20/29/29153LS0/640/29153LS0.jpg",
		"headline": "Grohtherm SmartControl",
		"subheadline": "Safety mixer for concealed installation with one valve",
		"textblock_1st_text": "29153LS0",
		"textblock_2nd_text": "Grohtherm SmartControl thermostat for shower, with concealed installation and one valve. Square shape, Moon White, made in Germany by GROHE. Eco-friendly and safety features",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe-middleeast.com/en_cy/product/29153LS0",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe-middleeast.com/en_cy/our-service/showrooms-installer.html#productline=G422",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "29156LS0",
		"image": "//cdn.cloud.grohe.com/prod/20/29/29156LS0/640/29156LS0.jpg",
		"headline": "Grohtherm SmartControl",
		"subheadline": "Safety mixer  for concealed installation with 2 valves",
		"textblock_1st_text": "29156LS0",
		"textblock_2nd_text": "Grohtherm SmartControl thermostat for shower or bath, for concealed installation, with two valves. Square shape, Moon White, made in Germany by GROHE. Eco-friendly and safety features",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe-middleeast.com/en_cy/product/29156LS0",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe-middleeast.com/en_cy/our-service/showrooms-installer.html#productline=G422",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "29157LS0",
		"image": "//cdn.cloud.grohe.com/prod/20/29/29157LS0/640/29157LS0.jpg",
		"headline": "Grohtherm SmartControl",
		"subheadline": "Safety mixer for concealed installation with 3 valves",
		"textblock_1st_text": "29157LS0",
		"textblock_2nd_text": "Grohtherm SmartControl thermostat for shower or bath, for concealed installation, with three valves. Square shape, Moon White, made in Germany by GROHE. Eco-friendly and safety features",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe-middleeast.com/en_cy/product/29157LS0",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe-middleeast.com/en_cy/our-service/showrooms-installer.html#productline=G422",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26370000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26370000/640/26370000.jpg",
		"headline": "Euphoria Cube",
		"subheadline": "Shower outlet elbow 1/2\"",
		"textblock_1st_text": "26370000",
		"textblock_2nd_text": "Eurocube Shower outlet elbow with wall holder, chrome finish and German engineered.",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe-middleeast.com/en_cy/product/26370000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe-middleeast.com/en_cy/our-service/showrooms-installer.html#productline=G334",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "14055000",
		"image": "//cdn.cloud.grohe.com/prod/10/14/14055000/640/14055000.jpg",
		"headline": "",
		"subheadline": "Backflow protection combination",
		"textblock_1st_text": "14055000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe-middleeast.com/en_cy/product/14055000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe-middleeast.com/en_cy/our-service/showrooms-installer.html#productline=G452",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "34705000",
		"image": "//cdn.cloud.grohe.com/prod/30/34/34705000/640/34705000.jpg",
		"headline": "Grohtherm SmartControl",
		"subheadline": "Perfect shower set with Rainshower SmartActive 310",
		"textblock_1st_text": "34705000",
		"textblock_2nd_text": "Grohtherm SmartControl Perfect Shower set with thermostat, for concealed installation with three valves, head shower, hand shower, shower arm, hose. Round shape. Chrome finish, made in Germany.",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe-middleeast.com/en_cy/product/34705000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe-middleeast.com/en_cy/our-service/showrooms-installer.html#productline=G422",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "29121000",
		"image": "//cdn.cloud.grohe.com/prod/20/29/29121000/640/29121000.jpg",
		"headline": "Grohtherm SmartControl",
		"subheadline": "Safety mixer for concealed installation with 3 valves",
		"textblock_1st_text": "29121000",
		"textblock_2nd_text": "Grohtherm SmartControl thermostat for shower or bath, for concealed installation, with three valves. Round shape, chrome finish, made in Germany by GROHE. Eco-friendly and safety features",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe-middleeast.com/en_cy/product/29121000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe-middleeast.com/en_cy/our-service/showrooms-installer.html#productline=G422",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "29123000",
		"image": "//cdn.cloud.grohe.com/prod/20/29/29123000/640/29123000.jpg",
		"headline": "Grohtherm SmartControl",
		"subheadline": "Safety mixer for concealed installation with one valve",
		"textblock_1st_text": "29123000",
		"textblock_2nd_text": "Grohtherm SmartControl thermostat for shower, with concealed installation and one valve. Square shape, chrome finish, made in Germany by GROHE. Eco-friendly and safety features",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe-middleeast.com/en_cy/product/29123000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe-middleeast.com/en_cy/our-service/showrooms-installer.html#productline=G422",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "34706000",
		"image": "//cdn.cloud.grohe.com/prod/30/34/34706000/640/34706000.jpg",
		"headline": "Grohtherm SmartControl",
		"subheadline": "Perfect shower set withRainshower SmartActive 310 Cube",
		"textblock_1st_text": "34706000",
		"textblock_2nd_text": "Grohtherm SmartControl Perfect Shower set with thermostat, for concealed installation with three valves, head shower, hand shower, shower arm, hose. Square shape. Chrome finish, made in Germany.",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe-middleeast.com/en_cy/product/34706000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe-middleeast.com/en_cy/our-service/showrooms-installer.html#productline=G422",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26443LS0",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26443LS0/640/26443LS0.jpg",
		"headline": "Rainshower System SmartControl Duo 360",
		"subheadline": "Combi shower system with safety mixer, exposed/concealed",
		"textblock_1st_text": "26443LS0",
		"textblock_2nd_text": "GROHE Rainshower SmartControl 360 DUO Combi shower system with thermostat. Chrome, eco-friendly and made in Germany: 360mm head shower (white spray plate) with GROHE TrioMassage spray and 115mm hand shower with two sprays.",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe-middleeast.com/en_cy/product/26443LS0",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe-middleeast.com/en_cy/our-service/showrooms-installer.html#productline=G421",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26449000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26449000/640/26449000.jpg",
		"headline": "",
		"subheadline": "Concealed body for exposed/concealed variants",
		"textblock_1st_text": "26449000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe-middleeast.com/en_cy/product/26449000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe-middleeast.com/en_cy/our-service/showrooms-installer.html#productline=G216",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27296002",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27296002/640/27296002.jpg",
		"headline": "Euphoria System 260",
		"subheadline": "Shower system with Safety Mixer for wall mounting",
		"textblock_1st_text": "27296002",
		"textblock_2nd_text": "GROHE Euphoria 260 Shower System with thermostat, 260mm 3-spray head shower and 110mm 3-spray hand shower in chrome. Easy to fit and clean. German engineering",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe-middleeast.com/en_cy/product/27296002",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe-middleeast.com/en_cy/our-service/showrooms-installer.html#productline=G236",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26224001",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26224001/640/26224001.jpg",
		"headline": "Tempesta Cosmopolitan System 210",
		"subheadline": "Shower system with single lever mixer for wall mounting",
		"textblock_1st_text": "26224001",
		"textblock_2nd_text": "GROHE Tempesta Cosmopolitan 210 Shower System with single lever mixer, 210mm head shower and 100mm two-spray hand shower in chrome. Easy to fit and clean. German engineering",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe-middleeast.com/en_cy/product/26224001",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe-middleeast.com/en_cy/our-service/showrooms-installer.html#productline=G361",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26453000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26453000/640/26453000.jpg",
		"headline": "Tempesta Cosmopolitan System 200",
		"subheadline": "Shower system with diverter for wall mounting",
		"textblock_1st_text": "26453000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe-middleeast.com/en_cy/product/26453000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe-middleeast.com/en_cy/our-service/showrooms-installer.html#productline=G361",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26452000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26452000/640/26452000.jpg",
		"headline": "Tempesta System 200",
		"subheadline": "Shower system with diverter for wall mounting",
		"textblock_1st_text": "26452000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe-middleeast.com/en_cy/product/26452000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe-middleeast.com/en_cy/our-service/showrooms-installer.html#productline=G391",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "35600000",
		"image": "//cdn.cloud.grohe.com/prod/30/35/35600000/640/35600000.jpg",
		"headline": "Rapido SmartBox",
		"subheadline": "Universal rough-in box, 1/2\"",
		"textblock_1st_text": "35600000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe-middleeast.com/en_cy/product/35600000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe-middleeast.com/en_cy/our-service/showrooms-installer.html#productline=G452",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "29118000",
		"image": "//cdn.cloud.grohe.com/prod/20/29/29118000/640/29118000.jpg",
		"headline": "Grohtherm SmartControl",
		"subheadline": "Safety mixer for concealed installation with one valve",
		"textblock_1st_text": "29118000",
		"textblock_2nd_text": "Grohtherm SmartControl thermostat for shower, with concealed installation and one valve. Round shape, chrome finish, made in Germany by GROHE. Eco-friendly and safety features",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe-middleeast.com/en_cy/product/29118000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe-middleeast.com/en_cy/our-service/showrooms-installer.html#productline=G422",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "29119000",
		"image": "//cdn.cloud.grohe.com/prod/20/29/29119000/640/29119000.jpg",
		"headline": "Grohtherm SmartControl",
		"subheadline": "Safety mixer  for concealed installation with 2 valves",
		"textblock_1st_text": "29119000",
		"textblock_2nd_text": "Grohtherm SmartControl thermostat for shower or bath, for concealed installation, with two valves. Round shape, chrome finish, made in Germany by GROHE. Eco-friendly and safety features",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe-middleeast.com/en_cy/product/29119000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe-middleeast.com/en_cy/our-service/showrooms-installer.html#productline=G422",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "29120000",
		"image": "//cdn.cloud.grohe.com/prod/20/29/29120000/640/29120000.jpg",
		"headline": "Grohtherm SmartControl",
		"subheadline": "Safety mixer  for concealed installation with 2 valves <br />and integrated shower holder",
		"textblock_1st_text": "29120000",
		"textblock_2nd_text": "Grohtherm SmartControl thermostat for shower or bath, for concealed installation, with two valves and integrated shower union. Round shape, chrome finish, made in Germany by GROHE. Eco-friendly and safety features",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe-middleeast.com/en_cy/product/29120000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe-middleeast.com/en_cy/our-service/showrooms-installer.html#productline=G422",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26475LS0",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26475LS0/640/26475LS0.jpg",
		"headline": "Rainshower SmartActive 310",
		"subheadline": "Head shower set 430 mm, 2 sprays",
		"textblock_1st_text": "26475LS0",
		"textblock_2nd_text": "GROHE Rainshower 310 SmartActive head shower set with 2 spray options. 310mm wall-mounted showerhead with 400mm shower arm, chrome finish and white spray plate, round shape. Made in Germany",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe-middleeast.com/en_cy/product/26475LS0",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe-middleeast.com/en_cy/our-service/showrooms-installer.html#productline=G480",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26477LS0",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26477LS0/640/26477LS0.jpg",
		"headline": "Rainshower SmartActive 310",
		"subheadline": "Head shower set ceiling 142 mm, 2 sprays",
		"textblock_1st_text": "26477LS0",
		"textblock_2nd_text": "GROHE Rainshower 310 SmartActive head shower set with 2 spray options. 310mm ceiling-mounted showerhead with 142mm shower arm, chrome finish and white spray plate, round shape. Made in Germany",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe-middleeast.com/en_cy/product/26477LS0",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe-middleeast.com/en_cy/our-service/showrooms-installer.html#productline=G480",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26479LS0",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26479LS0/640/26479LS0.jpg",
		"headline": "Rainshower SmartActive 310 Cube",
		"subheadline": "Head shower set 430 mm, 2 sprays",
		"textblock_1st_text": "26479LS0",
		"textblock_2nd_text": "GROHE Rainshower 310 SmartActive CUBE head shower set with 2 spray options. 310mm wall-mounted showerhead with 400mm shower arm, chrome finish and white spray plate, square shape. Made in Germany",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe-middleeast.com/en_cy/product/26479LS0",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe-middleeast.com/en_cy/our-service/showrooms-installer.html#productline=G480",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26481LS0",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26481LS0/640/26481LS0.jpg",
		"headline": "Rainshower SmartActive 310 Cube",
		"subheadline": "Head shower set ceiling 142 mm, 2 sprays",
		"textblock_1st_text": "26481LS0",
		"textblock_2nd_text": "GROHE Rainshower 310 SmartActive CUBE head shower set with 2 spray options. 310mm ceiling-mounted showerhead with 142mm shower arm, chrome finish and white spray plate, square shape. Made in Germany",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe-middleeast.com/en_cy/product/26481LS0",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe-middleeast.com/en_cy/our-service/showrooms-installer.html#productline=G480",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27473001",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27473001/640/27473001.jpg",
		"headline": "Euphoria System 260",
		"subheadline": "Shower system with single lever mixer for wall mounting",
		"textblock_1st_text": "27473001",
		"textblock_2nd_text": "GROHE Euphoria 260 Shower System with single lever mixer, water-saving SmartControl 260mm 3-spray head shower and 110mm 3-spray hand shower in chrome. German engineering",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe-middleeast.com/en_cy/product/27473001",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe-middleeast.com/en_cy/our-service/showrooms-installer.html#productline=G236",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26381001",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26381001/640/26381001.jpg",
		"headline": "Tempesta System 210",
		"subheadline": "Shower system with diverter for wall mounting",
		"textblock_1st_text": "26381001",
		"textblock_2nd_text": "GROHE New Tempesta 210 FLEX Shower System with diverter; compatible with all existing valves for easy upgrades. Made in Germany with 210m two-spray head shower and 100mm hand shower.",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe-middleeast.com/en_cy/product/26381001",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe-middleeast.com/en_cy/our-service/showrooms-installer.html#productline=G391",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27635000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27635000/640/27635000.jpg",
		"headline": "Rainshower Icon 150",
		"subheadline": "Hand shower 2 sprays",
		"textblock_1st_text": "27635000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe-middleeast.com/en_cy/product/27635000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe-middleeast.com/en_cy/our-service/showrooms-installer.html#productline=G233",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26067000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26067000/640/26067000.jpg",
		"headline": "Rainshower Cosmopolitan 310",
		"subheadline": "Head shower set ceiling 142 mm, 1 spray",
		"textblock_1st_text": "26067000",
		"textblock_2nd_text": "GROHE Rainshower Cosmopolitan 310, head shower set, ceiling shower arm 142 mm, 9.5 L / min",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe-middleeast.com/en_cy/product/26067000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe-middleeast.com/en_cy/our-service/showrooms-installer.html#productline=G372",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27367000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27367000/640/27367000.jpg",
		"headline": "Euphoria Cosmopolitan Stick",
		"subheadline": "Hand shower 1 spray",
		"textblock_1st_text": "27367000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe-middleeast.com/en_cy/product/27367000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe-middleeast.com/en_cy/our-service/showrooms-installer.html#productline=G275",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27368000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27368000/640/27368000.jpg",
		"headline": "Euphoria Cosmopolitan Stick",
		"subheadline": "Shower rail set 1 spray",
		"textblock_1st_text": "27368000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe-middleeast.com/en_cy/product/27368000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe-middleeast.com/en_cy/our-service/showrooms-installer.html#productline=G275",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27374000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27374000/640/27374000.jpg",
		"headline": "Rainshower System 210",
		"subheadline": "Shower system with safety mixer and side showers",
		"textblock_1st_text": "27374000",
		"textblock_2nd_text": "GROHE Rainshower 210 shower system with thermostat and body jets",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe-middleeast.com/en_cy/product/27374000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe-middleeast.com/en_cy/our-service/showrooms-installer.html#productline=G212",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27420001",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27420001/640/27420001.jpg",
		"headline": "Euphoria 180",
		"subheadline": "Shower system with Safety Mixer for wall mounting",
		"textblock_1st_text": "27420001",
		"textblock_2nd_text": "GROHE Euphoria 180 Shower System with thermostat; chrome and German engineered with 180m head shower and 110mm three-spray hand shower.",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe-middleeast.com/en_cy/product/27420001",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe-middleeast.com/en_cy/our-service/showrooms-installer.html#productline=G236",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27421001",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27421001/640/27421001.jpg",
		"headline": "Euphoria System 180",
		"subheadline": "Shower system with diverter <br />for wall mounting",
		"textblock_1st_text": "27421001",
		"textblock_2nd_text": "GROHE Euphoria 180 shower system with diverter, GROHE EcoJoy 9.5 l/min",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe-middleeast.com/en_cy/product/27421001",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe-middleeast.com/en_cy/our-service/showrooms-installer.html#productline=G236",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27074000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27074000/640/27074000.jpg",
		"headline": "Rainshower",
		"subheadline": "Wall hand shower holder",
		"textblock_1st_text": "27074000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe-middleeast.com/en_cy/product/27074000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe-middleeast.com/en_cy/our-service/showrooms-installer.html#productline=G090",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27174001",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27174001/640/27174001.jpg",
		"headline": "Rainshower System 400",
		"subheadline": "Shower system with Safety Mixer for wall mounting",
		"textblock_1st_text": "27174001",
		"textblock_2nd_text": "GROHE Rainshower 400 shower system with thermostat",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe-middleeast.com/en_cy/product/27174001",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe-middleeast.com/en_cy/our-service/showrooms-installer.html#productline=G212",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27251000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27251000/640/27251000.jpg",
		"headline": "Rainshower F-Series 5'",
		"subheadline": "Side shower 1 spray",
		"textblock_1st_text": "27251000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe-middleeast.com/en_cy/product/27251000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe-middleeast.com/en_cy/our-service/showrooms-installer.html#productline=G231",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26052000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26052000/640/26052000.jpg",
		"headline": "Rainshower Cosmopolitan 210",
		"subheadline": "Head shower set 286 mm, 1 spray",
		"textblock_1st_text": "26052000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe-middleeast.com/en_cy/product/26052000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe-middleeast.com/en_cy/our-service/showrooms-installer.html#productline=G372",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26053000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26053000/640/26053000.jpg",
		"headline": "Rainshower Cosmopolitan 210",
		"subheadline": "Head shower set ceiling 142 mm, 1 spray",
		"textblock_1st_text": "26053000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe-middleeast.com/en_cy/product/26053000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe-middleeast.com/en_cy/our-service/showrooms-installer.html#productline=G372",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26056000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26056000/640/26056000.jpg",
		"headline": "Rainshower Cosmopolitan 310",
		"subheadline": "Head shower set 380 mm, 1 spray",
		"textblock_1st_text": "26056000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe-middleeast.com/en_cy/product/26056000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe-middleeast.com/en_cy/our-service/showrooms-installer.html#productline=G372",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26064000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26064000/640/26064000.jpg",
		"headline": "Rainshower Allure 230",
		"subheadline": "Head shower set 286 mm, 1 spray",
		"textblock_1st_text": "26064000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe-middleeast.com/en_cy/product/26064000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe-middleeast.com/en_cy/our-service/showrooms-installer.html#productline=G363",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26071000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26071000/640/26071000.jpg",
		"headline": "Rainshower F-Series 10'",
		"subheadline": "Head shower set ceiling 142 mm, 1 spray",
		"textblock_1st_text": "26071000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe-middleeast.com/en_cy/product/26071000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe-middleeast.com/en_cy/our-service/showrooms-installer.html#productline=G231",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26066000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26066000/640/26066000.jpg",
		"headline": "Rainshower Cosmopolitan 310",
		"subheadline": "Head shower set 380 mm, 1 spray",
		"textblock_1st_text": "26066000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe-middleeast.com/en_cy/product/26066000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe-middleeast.com/en_cy/our-service/showrooms-installer.html#productline=G372",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27032001",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27032001/640/27032001.jpg",
		"headline": "Rainshower System 210",
		"subheadline": "Shower system with Safety Mixer for wall mounting",
		"textblock_1st_text": "27032001",
		"textblock_2nd_text": "GROHE Rainshower 210 shower system with thermostat",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe-middleeast.com/en_cy/product/27032001",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe-middleeast.com/en_cy/our-service/showrooms-installer.html#productline=G212",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27055000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27055000/640/27055000.jpg",
		"headline": "Rainshower",
		"subheadline": "Wall hand shower holder",
		"textblock_1st_text": "27055000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe-middleeast.com/en_cy/product/27055000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe-middleeast.com/en_cy/our-service/showrooms-installer.html#productline=G090",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27057000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27057000/640/27057000.jpg",
		"headline": "Rainshower",
		"subheadline": "Shower outlet elbow 1/2\"",
		"textblock_1st_text": "27057000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe-middleeast.com/en_cy/product/27057000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe-middleeast.com/en_cy/our-service/showrooms-installer.html#productline=G090",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27058000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27058000/640/27058000.jpg",
		"headline": "Rainshower System 210",
		"subheadline": "Shower system with diverter <br />for wall mounting",
		"textblock_1st_text": "27058000",
		"textblock_2nd_text": "GROHE Rainshower 210 shower system with diverter",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe-middleeast.com/en_cy/product/27058000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe-middleeast.com/en_cy/our-service/showrooms-installer.html#productline=G212",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27784000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27784000/640/27784000.jpg",
		"headline": "Power&Soul",
		"subheadline": "Shower rail, 600 mm",
		"textblock_1st_text": "27784000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe-middleeast.com/en_cy/product/27784000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe-middleeast.com/en_cy/our-service/showrooms-installer.html#productline=G316",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27964000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27964000/640/27964000.jpg",
		"headline": "Euphoria System 210",
		"subheadline": "Shower system with Safety Mixer for wall mounting",
		"textblock_1st_text": "27964000",
		"textblock_2nd_text": "GROHE Euphoria 210 shower system with thermostat",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe-middleeast.com/en_cy/product/27964000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe-middleeast.com/en_cy/our-service/showrooms-installer.html#productline=G236",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27475001",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27475001/640/27475001.jpg",
		"headline": "Euphoria System 260",
		"subheadline": "Shower system with Bath Safety Mixer for wall mounting",
		"textblock_1st_text": "27475001",
		"textblock_2nd_text": "GROHE Euphoria 260 Bath/Shower System with thermostat for bathtubs, water saving SmartControl 260mm 3-spray head shower and 110mm 3-spray hand shower in chrome. German engineering",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe-middleeast.com/en_cy/product/27475001",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe-middleeast.com/en_cy/our-service/showrooms-installer.html#productline=G236",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26065000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26065000/640/26065000.jpg",
		"headline": "Rainshower Allure 230",
		"subheadline": "Head shower set ceiling 154 mm, 1 spray",
		"textblock_1st_text": "26065000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe-middleeast.com/en_cy/product/26065000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe-middleeast.com/en_cy/our-service/showrooms-installer.html#productline=G363",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	}
];


//////////////////
// WEBPACK FOOTER
// ./src/data/shower_products_en_cy.json
// module id = 826
// module chunks = 0